import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';

import { getTypeSenseAPIKeys } from './typeSenseAPIKeys';
import {
  TypesenseAPIKeys,
  RawTypesenseAPIKeys,
} from './typeSenseAPIKeys.types';

const TYPESENSE_API_KEYS = 'TypeSenseAPIKeys';

export const useGetTypeSenseAPIKeys = (): {
  data: TypesenseAPIKeys | undefined;
  isRefetching: boolean;
} & Omit<
  ReturnType<typeof useQuery<RawTypesenseAPIKeys>>,
  'data' | 'isRefetching'
> => {
  const { data, isRefetching, ...restProps } = useQuery({
    queryKey: [TYPESENSE_API_KEYS],
    queryFn: getTypeSenseAPIKeys,
    staleTime: 90000, // 1.5 minutes
    refetchInterval: 90000, // 1.5 minutes
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
  });

  useEffect(() => {
    if (isRefetching) {
      console.debug('## Refetching TypeSense API Keys');
    }
  }, [isRefetching]);

  const processedData: TypesenseAPIKeys | undefined = data
    ? (Object.fromEntries(
        Object.entries(data).map(([key, value]) => [key.toLowerCase(), value]),
      ) as TypesenseAPIKeys)
    : undefined;

  return { ...restProps, data: processedData, isRefetching };
};
